import { Mail } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconMail12Line = createIcon(Mail, 12, "Line");
export const IconMail16Line = createIcon(Mail, 16, "Line");
export const IconMail20Line = createIcon(Mail, 20, "Line");
export const IconMail24Line = createIcon(Mail, 24, "Line");
export const IconMail32Line = createIcon(Mail, 32, "Line");
export const IconMail48Line = createIcon(Mail, 48, "Line");
export const IconMail64Line = createIcon(Mail, 64, "Line");
